// extracted by mini-css-extract-plugin
module.exports = {"panelSeparator":"HomePosts_panelSeparator__l83Qp","posts":"HomePosts_posts__dw0Ep","postsContent":"HomePosts_postsContent__lf27V","postsAction":"HomePosts_postsAction__8XyQd"};